import { userTempInventoryState } from './userTempInventoryState';
import { refreshUserTempInventory } from './refreshUserTempInventory';

export async function connectUserTempInventory(userId: string): Promise<void> {
  if (userTempInventoryState.userId !== userId) {
    userTempInventoryState.userId = userId;
    userTempInventoryState.files = [];
    userTempInventoryState.ready = false;
  }
  if (userTempInventoryState.ready) return;
  await refreshUserTempInventory();
}
